/**
 * SCROLL LOCK UTILITY
 * 
 * Centralized scroll locking for drawers, modals, and popovers.
 * Handles iOS Safari properly with position: fixed approach.
 * Manages lock count to coordinate multiple overlays.
 */

(function() {
  'use strict';
  
  // Keep track of how many times we've locked (for nested overlays)
  let lockCount = 0;
  
  // Store the scroll position before locking
  let scrollPosition = 0;
  
  /**
   * Lock body scroll
   * Prevents background scrolling on both desktop and iOS
   */
  function lockScroll() {
    lockCount++;
    
    // Only apply the lock styles on the first lock
    if (lockCount === 1) {
      // Store current scroll position
      scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      
      // Add no-scroll class for desktop (overflow: hidden)
      document.documentElement.classList.add('no-scroll');
      
      // iOS-specific fix: position fixed with top offset
      // This prevents elastic scrolling and touch-based scroll on iOS
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition}px`;
      document.body.style.width = '100%';
    }
  }
  
  /**
   * Unlock body scroll
   * Restores scrolling and scroll position
   */
  function unlockScroll() {
    lockCount--;
    
    // Only remove the lock styles when all locks are released
    if (lockCount <= 0) {
      lockCount = 0; // Prevent negative counts
      
      // Remove no-scroll class
      document.documentElement.classList.remove('no-scroll');
      
      // Restore body styles
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      
      // Restore scroll position
      window.scrollTo(0, scrollPosition);
    }
  }
  
  /**
   * Check if scroll is currently locked
   */
  function isLocked() {
    return lockCount > 0;
  }
  
  /**
   * Get current lock count (useful for debugging)
   */
  function getLockCount() {
    return lockCount;
  }
  
  /**
   * Force reset all locks (emergency use only)
   */
  function forceUnlock() {
    lockCount = 0;
    unlockScroll();
  }
  
  // Expose the utility globally
  window.ScrollLock = {
    lock: lockScroll,
    unlock: unlockScroll,
    isLocked: isLocked,
    getLockCount: getLockCount,
    forceUnlock: forceUnlock
  };
  
})();